import React, { useState } from "react";
import "../../styles/ExamTimetables.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { FaSearch, FaCalendarAlt, FaArrowRight, FaExternalLinkAlt } from "react-icons/fa";

// ------------------ DATA STRUCTURE ------------------

const SPPU_LINKS = [
  {
    title: "SPPU Official Timetable Portal",
    link: "https://exam.unipune.ac.in/Pages/Schedules.html",
    type: "SPPU"
  },
  {
    title: "SPPU Theory Exam Timetables",
    link: "https://exam.unipune.ac.in/Pages/ExamTimetable.html",
    type: "SPPU"
  },
  {
    title: "SPPU Practical Exam Timetables",
    link: "https://exam.unipune.ac.in/Pages/PracticalTimetable.html",
    type: "SPPU"
  }
];

const INTERNAL_THEORY = {
  FY: {
    BA: "/pdfs/timetables/sample-timetable.pdf",
    BSc: "/pdfs/timetables/sample-timetable.pdf",
    BScCS: "/pdfs/timetables/sample-timetable.pdf"
  },
  SY: {
    BA: "/pdfs/timetables/sample-timetable.pdf",
    BSc: "/pdfs/timetables/sample-timetable.pdf",
    BScCS: "/pdfs/timetables/sample-timetable.pdf"
  },
  TY: {
    BA: "/pdfs/timetables/sample-timetable.pdf",
    BSc: "/pdfs/timetables/sample-timetable.pdf",
    BScCS: "/pdfs/timetables/sample-timetable.pdf"
  }
};

const INTERNAL_PRACTICAL = {
  FY: {
    BA: "/pdfs/timetables/sample-timetable.pdf",
    BSc: "/pdfs/timetables/sample-timetable.pdf",
    BScCS: "/pdfs/timetables/sample-timetable.pdf"
  },
  SY: {
    BA: "/pdfs/timetables/sample-timetable.pdf",
    BSc: "/pdfs/timetables/sample-timetable.pdf",
    BScCS: "/pdfs/timetables/sample-timetable.pdf"
  },
  TY: {
    BA: "/pdfs/timetables/sample-timetable.pdf",
    BSc: "/pdfs/timetables/sample-timetable.pdf",
    BScCS: "/pdfs/timetables/sample-timetable.pdf"
  }
};

// ----------------------------------------------------

export default function TimetablePage() {
  const [search, setSearch] = useState("");

  const openLink = (link) => {
    window.open(link, "_blank");
  };

  const filterCheck = (text) => text.toLowerCase().includes(search.toLowerCase());

  return (
    <>
      <Navbar />

      <div className="timetable-page fade-in-page">

        <h1 className="timetable-title">📅 Examination Timetables</h1>

        {/* SEARCH BAR */}
        <div className="timetable-search-box">
          <FaSearch className="timetable-search-icon" />
          <input
            type="text"
            placeholder="Search timetable..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* ------------------ SPPU SECTION ------------------ */}
        <h2 className="section-title">🔗 SPPU Official Timetables</h2>

        <div className="timetable-grid">
          {SPPU_LINKS.filter((t) => filterCheck(t.title)).map((t, i) => (
            <div className="timetable-card slide-up" key={i} onClick={() => openLink(t.link)}>
              <FaCalendarAlt className="timetable-icon" />

              <div>
                <h3>{t.title}</h3>
                <p className="timetable-type">Official SPPU Link</p>
              </div>

              <FaExternalLinkAlt className="open-icon" />
            </div>
          ))}
        </div>

        {/* ------------------ INTERNAL THEORY ------------------ */}
        <h2 className="section-title">📘 Internal Theory Timetables</h2>

        {Object.keys(INTERNAL_THEORY).map((year) => (
          <div className="year-block" key={year}>
            <h3 className="year-heading">{year}</h3>

            <div className="timetable-grid">
              {Object.keys(INTERNAL_THEORY[year])
                .filter((course) => filterCheck(course + " " + year + " theory"))
                .map((course) => (
                  <div
                    className="timetable-card slide-up"
                    key={course}
                    onClick={() => openLink(INTERNAL_THEORY[year][course])}
                  >
                    <FaCalendarAlt className="timetable-icon" />
                    <div>
                      <h3>{course} Theory Timetable</h3>
                      <p className="timetable-type">Internal Exam</p>
                    </div>
                    <FaArrowRight className="open-icon" />
                  </div>
                ))}
            </div>
          </div>
        ))}

        {/* ------------------ INTERNAL PRACTICAL ------------------ */}
        <h2 className="section-title">🧪 Internal Practical Timetables</h2>

        {Object.keys(INTERNAL_PRACTICAL).map((year) => (
          <div className="year-block" key={year}>
            <h3 className="year-heading">{year}</h3>

            <div className="timetable-grid">
              {Object.keys(INTERNAL_PRACTICAL[year])
                .filter((course) => filterCheck(course + " " + year + " practical"))
                .map((course) => (
                  <div
                    className="timetable-card slide-up"
                    key={course}
                    onClick={() => openLink(INTERNAL_PRACTICAL[year][course])}
                  >
                    <FaCalendarAlt className="timetable-icon" />
                    <div>
                      <h3>{course} Practical Timetable</h3>
                      <p className="timetable-type">Internal Practical Exam</p>
                    </div>
                    <FaArrowRight className="open-icon" />
                  </div>
                ))}
            </div>
          </div>
        ))}

        {search && (
          <p className="no-results fade-text">
            Showing results for: <strong>{search}</strong>
          </p>
        )}
      </div>

      <Footer />
    </>
  );
}
